import React from "react";
import FormElement from "./formElement";
import { Select } from "antd";
import CustomChip from "../../../general/chips";
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getAccountingCodes } from "../../../../store/actions/precog/accounting";

const Option = Select.Option;

const MovementsFilters = ({accountCodeFilter, setAccountCodeFilter, movementsFiltersChips, setMovementsFiltersChips}) => {

  const accountCodes = useSelector(state => state.precog.accountingCodes?.data);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAccountingCodes());
    // setMovementsFiltersChips(filterListChips);
  }, []);

  const accountCodeList = accountCodes.map((ac, index) => {
    return (
      <Option 
        key={`accCode_${index}`}
        value={ac.code}
        label={ac.title}
      >
        <div className="accountCodesSelection">
          <span style={{marginLeft: "8px"}}>{ac.title}</span>
        </div>
      </Option>
    );
  });
	
  return (
    <div style={{margin: "24px 0 0 8px", width: "50%", display: "flex"}}>
      <FormElement label="Movimenti bancari" style={{flexGrow: 1}}>
        <div style={{display: "flex"}}>
          <FormElement label="Seleziona banca" style={{flexGrow: 1, marginTop: 6}}>
            <Select
              getPopupContainer={trigger => trigger.parentNode}
              style={{marginTop: "5px"}}
              placeholder={"Seleziona conto"}
              defaultValue={accountCodeFilter}
              allowClear
              onChange={value => {
                
                setAccountCodeFilter(value);
              }}
            >
              {accountCodeList}
            </Select>
          </FormElement>
        </div>
      </FormElement>
      <div className="movements-filters-chips-container">
        {
          movementsFiltersChips?.map((el, key) => {
            return (
              <CustomChip
                style={{ marginLeft: "20px", cursor: "pointer" }}
                key={`movementFilterChips_${el.key}`}
                active={ movementsFiltersChips[key].active}
                className={movementsFiltersChips[key].active ? "active" : ""}
                onClick={() => {
                  const cloneMovementsFiltersChips = [...movementsFiltersChips];
                  cloneMovementsFiltersChips[key].active = !cloneMovementsFiltersChips[key].active;
                  setMovementsFiltersChips(cloneMovementsFiltersChips);
                }}
                description={el.desc}
              />
            );
          })
        }
      </div>
    </div>
  );
};

export default MovementsFilters;